<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Products" />
  
      <!-- Add New Product Button -->
      <button class="add-product-btn" @click="addNewProduct">Add New Product</button>
  
      <!-- Table Structure -->
      <table id="productTable">
        <thead>
          <tr>
            <!-- <th>ID</th> -->
            <th>Name</th>
            <!-- <th>Category ID</th> -->
            <th>Price</th>
            <!-- <th>Cost</th> -->
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product) in products" :key="product.id">
            <!-- <td>{{ product.id }}</td> -->
            <td>{{ getProductName(product) }}</td>
            <!-- <td>{{ product.catId }}</td> -->
            <td>{{ product.price }}</td>
            <!-- <td>{{ product.cost }}</td> -->
            <td>{{ product.isSuspend ? 'Suspended' : 'Active' }}</td>
            <td class="action-buttons">
              <!-- <button data-tooltip="Menu" @click="handleMenu()">
                <img src="https://cdn-icons-png.flaticon.com/512/1828/1828859.png" alt="Menu">
              </button> -->
              <button data-tooltip="Update" @click="handleUpdate(product)">
                <img src="@/assets/edit_icon.png" alt="Update">
              </button>
              <button :data-tooltip="product.isSuspend ? 'Activate' : 'Suspend'"  @click="handleSuspend(product)">
               <img 
                  :src="product.isSuspend ? 
                    require('@/assets/suspend_icon.png') : 
                    require('@/assets/suspend_icon.png')" 
                  :alt="product.isSuspend ? 'Deactivate' : 'Activate'"
                >


              </button>
              <!-- Hot Key Toggle Button -->
              <button 
                :data-tooltip="product.isHotKey ? 'Remove Hot Key' : 'Add Hot Key'"
                @click="toggleHotKey(product)"
              >
                <img 
                  :src="product.isHotKey 
                    ? require('@/assets/remove_Hotkey_icon.png')
                    : require('@/assets/add_hot_icon.png')" 
                  :alt="product.isHotKey ? 'Remove Hot Key' : 'Add Hot Key'"
                >
              </button>
              <!-- Delivery Menu Toggle Button -->
              <button 
                :data-tooltip="product.isDeliveryMenu ? 'Remove Delivery' : 'Add Delivery'"
                @click="toggleDeliveryMenu(product)"
              >
                <img style="mix-blend-mode: lighten;"
  :src="product.isDeliveryMenu 
    ? require('@/assets/delivery_product.jpg') 
    : require('@/assets/non_delivery.jpg')" 
  :alt="product.isDeliveryMenu ? 'Delivery Product' : 'Non-Delivery Product'"
>
              </button>
              <button data-tooltip="Delete" @click="handleDelete(product)">
                <img src="@/assets/delete_icon.png" alt="Delete">
              </button>
              <button data-tooltip="Tax" @click="handleTax(product)">
  <img src="@/assets/tax_icon.png" alt="Tax">
</button>
<button data-tooltip="Customize" @click="handleCustomize(product)">
  <img src="@/assets/customize.png" alt="Customize">
</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        products: [], 
        currentDate: "",
        currentTime: "",
        token: null,
        catId: null,
      };
    },
    mounted() {
      this.catId = this.$route.params.id; 
      this.token = localStorage.getItem('authToken'); 
      this.updateDateTime(); 
      setInterval(this.updateDateTime, 1000); 
      this.fetchProducts(); 
    },
    methods: {
      handleTax(product) {
        if (!this.$hasPermission('view taxes')){
        this.$toast.error('Not Permitted');
        return;
    }

const productName = product.languages?.[0]?.name || 'defaultName';
console.log(productName);
this.$router.push({ 
name: "TaxProductComponent", 
params: { 
id: product.id, 
name: productName 
 } 
});

},

handleCustomize(product) {
  if (!this.$hasPermission('view customizations')){
        this.$toast.error('Not Permitted');
        return;
    }
  this.$router.push({ name: "CustomProductComponent", params: { id: product.id, price: product.price} });
},
async fetchProducts() {
  try {
    this.$root.isLoading = true;
    this.loading = true;
    
    const response = await axios.get(`${this.$BASE_API_URL}/api/products`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    
    if (response.data.status) {
      const allProducts = response.data.data || [];
      
      const transformedProducts = allProducts.map(product => ({
        ...product, 
        isSuspend: Boolean(Number(product.isSuspend)), 
      }));
      
      this.products = this.catId 
        ? transformedProducts.filter(product => product.catId == this.catId)
        : transformedProducts;
      
      console.log('Fetched products:', this.products);
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    this.$toast.error("Failed to load products");
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
      
      getProductName(product) {
        if (product.languages && product.languages.length > 0) {
          return product.languages[0].name; 
        }
        return "N/A"; 
      },
      
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
      
      addNewProduct() {
        if (!this.$hasPermission('create products')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ name: "AddProductComponent" });
      },
      
      // handleMenu() {
      //   this.$router.push({ name: "AddProductComponent" , params: { id: this.catId}});
      // },
      
      handleUpdate(product) {
         if (!this.$hasPermission('edit products')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ name: "EditProductComponent", params: { id: product.id } });
      },
      
      async handleSuspend(product) {
    // if (!this.$hasPermission('suspend products')) {
    //     this.$toast.error('Not Permitted for this action');
    //     return;
    // }
    
    try {
        this.$root.isLoading = true;
        this.loading = true;
        
        const response = await axios.put(
            `${this.$BASE_API_URL}/api/products/set_suspend/${product.id}`,
            { isSuspend: !product.isSuspend }, // Toggle the current status
            {
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            }
        );

        if (response.status >= 200 && response.status < 300) {
            product.isSuspend = !product.isSuspend; // Toggle the state locally
            this.$forceUpdate(); // Force UI update
            const status = product.isSuspend ? 'suspended' : 'activated';
            this.$toast.success(`Product ${status} successfully`);
        } else {
            this.$toast.error('Failed to update suspension status: ' + (response.data?.message || 'Unknown error'));
        }
    } catch (error) {
        console.error('Error toggling suspension status:', error);
        this.$toast.error(error.response?.data?.message || 'Error updating suspension status. Please try again.');
    } finally {
        this.$root.isLoading = false;
        this.loading = false;
    }
},
      
      async toggleHotKey(product) {
        if (!this.$hasPermission('edit hotkeys')){
        this.$toast.error('Not Permitted for this action');
        return;
    }
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const endpoint = product.isHotKey 
            ? `/api/products/unset_hotkey/${product.id}`
            : `/api/products/set_hotkey/${product.id}`;
          
          const response = await axios.put(
            `${this.$BASE_API_URL}${endpoint}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
          );
  
          if (response.status >= 200 && response.status < 300) {
            product.isHotKey = !product.isHotKey; // Toggle the state locally
            this.$forceUpdate(); // Force UI update
          } else {
            this.$toast.error('Failed to update hot key: ' + (response.data?.message || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error toggling hot key:', error);
          this.$toast.error(error.response?.data?.message || 'Error updating hot key. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      
      async toggleDeliveryMenu(product) {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const endpoint = product.isDeliveryMenu 
            ? `/api/products/unset_delivery_menu/${product.id}`
            : `/api/products/set_delivery_menu/${product.id}`;
          
          const response = await axios.put(
            `${this.$BASE_API_URL}${endpoint}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
          );
  
          if (response.status >= 200 && response.status < 300) {
            product.isDeliveryMenu = !product.isDeliveryMenu; 
            this.$forceUpdate(); 
          } else {
            this.$toast.error('Failed to update delivery menu: ' + (response.data?.message || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error toggling delivery menu:', error);
          this.$toast.error(error.response?.data?.message || 'Error updating delivery menu. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      
      async handleDelete(product) {
         if (!this.$hasPermission('delete products')){
        this.$toast.error('Not Permitted');
        return;
    }
        if (confirm(`Are you sure you want to delete ${this.getProductName(product)}?`)) {
          this.$root.isLoading = true; 
          this.loading = true;
            const response = await axios.delete(
              `${this.$BASE_API_URL}/api/products/${product.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
            );
  
            if (response.error) {
              this.$toast.error('Failed to delete product: ' + (response.data?.message || 'Unknown error'));
            } else {
              this.fetchProducts();
              this.$toast.success('Product deleted successfully!');
            }
         
        }
      this.$root.isLoading = false;
      this.loading = false;
      }
    },
  };
  </script>
    
    
    <!-- .action-buttons button[data-tooltip*="Delivery"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(270deg); /* Purple */
  } -->
  <style scoped>
  th,
  td {
    border: 1px solid;
    padding: 8px;
    text-align: left;
  }
  .add-product-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: .5rem;
    margin-right: .5rem;
  }
  .action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.2); 
    opacity: 0.8; 
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  /* Icon Colors */
  .action-buttons button[data-tooltip="Menu"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(180deg); /* Blue */
  }
  .action-buttons button[data-tooltip="Update"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); /* Green */
  }
  .action-buttons button[data-tooltip="Suspend"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(45deg); /* Orange */
  }

  .action-buttons button[data-tooltip*="Hot Key"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(0deg); /* Red-Orange */
  }

.action-buttons button[data-tooltip="Tax"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(210deg); /* Blue-ish */
}

.action-buttons button[data-tooltip="Customize"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(300deg); /* Pink-ish */
}
  </style>